import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const storageService = inject(StorageService);

  const skipTokenUrls = [
    '/checkRetailQrCode',
  ];

  if (skipTokenUrls.some(url => request.url.includes(url))) {
    return next(request);
  }
  
  const token = storageService.getToken();
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        // 'ngrok-skip-browser-warning': 'true',
      },
    });
  }

  return next(request);
};
